<template>
  <div>
    <b-row>
      <b-col cols="12">
        <d-select-input-search
          :options="clubs"
          :place-holder="$t('admin.duplicate.search-club-model')"
          class-name="bg-white mt-2 mb-3 w-75"
          icon="fa fa-search"
          @on:keydown="filterClubs($event)"
          @on:selected="onSelect"
        />
      </b-col>
      <b-col cols="4">
        <d-button
          :text="check ? 'admin.duplicate.select-all' : 'admin.duplicate.unselect-all'"
          class="d-btn-sm d-btn btn d-btn-success font-text-title mt-1"
          @on:button-click="onCheckAll"
        />
      </b-col>
      <b-col align="right">
        <div class="has-search">
          <span class="fa fa-search form-control-feedback"></span>
          <input
            type="text"
            class="form-control"
            v-model="filter"
            :placeholder="$t('components.doinsport.table.search')"
          >
        </div>
      </b-col>
    </b-row>
    <d-table
      identifier="category-shop"
      :tablefields="fields"
      :items="items"
      :per-page="itemsPerPage"
      :totalRows="totalRows"
      :is-busy="isBusy"
      :per-page-enabled="true"
      :tr-cursor-pointer="false"
      @per-page:update="onPerPageUpdate"
      @on:data-table-btn:checkbox="onDataTableCheck"
      @current-page:update="onPageUpdate"
    >
    </d-table>
    <div class="d-flex justify-content-end">
      <d-button
        :text="'admin.duplicate.proceed-to-edit'"
        class="d-btn-sm d-btn btn d-btn-success font-text-title mt-3"
        @on:button-click="onProceed"
      />
    </div>
  </div>
</template>
<script>
import {getAllCategoriesProducts, getAllProducts} from "@api/services/products/products.api";
import {isNotUndefinedAndNotNull} from "@/utils/classes";
import {getClubs} from "@api/services/club/club.api";

export default {
  data: () => ({
    items: [],
    clubs: [],
    filter: '',
    selectedClubId: '',
    isBusy: false,
    check: false,
    checkedCategory: null,
    timer: null,
    itemsPerPage: 10,
    totalRows: 1,
    currentPage: 1,
  }),
  props: {
    reload: {
      type: Boolean,
      default: false
    },
    filter: {
      type: String,
      default: ''
    },
    isArchived: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    reload: function () {
      this.loadShopProducts(this.itemsPerPage, this.currentPage, this.filter);
    },
    filter: function () {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.loadShopProducts(this.itemsPerPage, this.currentPage, this.filter);
      }, 400);
    }
  },
  computed: {
    getClubList() {
      return this.$store.getters['club/getClubList'];
    },
    selectedCategory() {
      return this.checkedCategory ? this.$t('admin.duplicate.shop-category.selected-shop-cat', {
        cat: this.checkedCategory.name,
        club: 'YouJump',
        name: this.checkedCategory.club.name
      }) : this.$t('admin.duplicate.shop-category.select-shop-cat');
    },
    alignCellsToLeft() {
      return this.$store.getters['layout/getInnerWidth'] >= 991 ? 'text-center' : 'text-left';
    },
    clubs() {
      return this.$store.getters['club/getClubs']
    },
    fields() {
      return [
        {
          key: "name",
          label: this.$t('admin.duplicate.shop-category.title'),
          sortable: true,
        },
        {
          key: "description",
          label: this.$t('admin.duplicate.shop-category.description'),
          sortable: true
        },
        {
          key: "club.name",
          label: this.$t('admin.duplicate.shop-category.club'),
        },
        {
          key: "actions",
          label: this.$t("general.actions.actions"),
        },
      ];
    },
    getCheckedCategoryList() {
      return this.$store.getters['duplicate/getCheckedCategoryList'];
    },
    getSelectedCategory() {
      return this.$store.getters['duplicate/getSelectedCategoryModel'];
    },
  },
  methods: {
    onSelect($event) {
      this.$store.commit('duplicate/setSelectedCategoryModel', null);

      if ($event === null) {
        this.selectedClubId = '';
        this.loadShopProducts(this.itemsPerPage, this.currentPage, this.filter);
      } else {
        this.selectedClubId = $event.item.id;
        this.loadShopProducts(this.itemsPerPage, this.currentPage, this.filter);
      }
    },
    onProceed() {
      this.$nextTick(() => {
        this.$router.push({name: 'duplicate_shop_category'});
      });
    },
    onDataTableCheck($event) {
      if ($event.checked) {
        this.$store.commit('duplicate/addToCategoryList', $event)
      } else {
        this.$store.commit('duplicate/removeFromCategoryList', $event)
      }
      this.$emit('reload-duplicate-table');
    },
    onCheckAll() {
      this.check = !this.check;

      for (const item of this.items) {
        item.checked = this.check;

        if (item.checked) {
          this.$store.commit('duplicate/addToCategoryList', item)
        } else {
          this.$store.commit('duplicate/removeFromCategoryList', item)
        }
      }
    },
    onPageUpdate(page) {
      this.loadShopProducts(this.itemsPerPage, page, this.filter);
    },
    onPerPageUpdate(itemsPerPage) {
      this.itemsPerPage = itemsPerPage;
      this.currentPage = 1;
      this.loadShopProducts(itemsPerPage, this.currentPage, this.filter);
    },
    loadShopProducts(itemsPerPage, currentPage, filter) {
      this.items = [];
      this.isBusy = true;
      const filterTag = 'asc';

      getAllCategoriesProducts(itemsPerPage, currentPage, filter, filterTag, null, this.selectedClubId)
        .then((response) => {

          this.totalRows = response.data['hydra:totalItems'];

          for (const item of response.data['hydra:member']) {
            item.actions = ['checkbox'];

            const checkIfChecked = this.getCheckedCategoryList.find(el => el.id === item.id);

            item.checked = !!isNotUndefinedAndNotNull(checkIfChecked);


            this.items.push(item);
          }
        })
        .finally(() => {
          this.isBusy = false;
        })
      ;
    },
    filterClubs(filter = '') {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.loadClubs(filter);
      }, 400);
    },
    loadClubs(filter = '') {
      this.clubs = [];

      getClubs(1, 500, filter)
        .then((response) => {

          for (const club of response.data['hydra:member']) {
            this.clubs.push({
              label: club.name,
              id: club.id,
              item: club,
              iri: club['@id'],
            });
          }
        })
      ;
    },
  },
  created() {
    this.clubs = this.getClubList;
    this.loadShopProducts(this.itemsPerPage, this.currentPage, this.filter);
  }
}
</script>
<style scoped lang="scss">
@import "@lazy/_b-card.scss";

/deep/ .card .card-body {
  padding-left: 25px;
  padding-right: 25px;
}

/deep/ .page-item.active .page-link {
  z-index: 0;
  color: #fff;
  background-color: #092772;
  border-color: #092772;
}
</style>
